import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['valueInput', 'label']
  static values = {
    actionPathTemplate: String, // e.g., "/applicant_screenings/:id/actions/add_profile"
    required: Boolean
  }

  connect () {
    this.form = this.element
  }

  select (event) {
    const button = event.currentTarget
    const selectedValue = button.dataset.value
    const selectedLabel = button.dataset.label

    this.valueInputTarget.value = selectedValue
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = selectedLabel
    }

    if (this.hasActionPathTemplateValue) {
      this.form.action = this.actionPathTemplateValue.replace(':id', selectedValue)
    }
  }

  submit (event) {
    if (this.requiredValue && !this.valueInputTarget.value) {
      event.preventDefault()
    }
  }
}
